module.exports = __webpack_public_path__ + "static/img/logo@2x.e24b7ee3.png";